import { useMutation } from '@tanstack/react-query';
import Config from 'src/common/Config';
import { Logger } from 'src/utils/Logger';

const API_URL = Config.getApiUrl();

type RecordEditActionParams = {
  documentId: string;
  actionText: string;
  source: 'SUGGESTED' | 'MANUAL';
  conversationId: string;
  clientId?: string;
};

export function useRecordEditAction() {
  const { mutate } = useMutation({
    mutationFn: async ({ documentId, ...body }: RecordEditActionParams) => {
      const response = await fetch(`${API_URL}/documents/${documentId}/edit-action`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });
      if (!response.ok) {
        Logger.error('Failed to record edit action', new Error('Failed to record edit action'), {
          documentId,
        });
      }
    },
  });

  return { recordAction: mutate };
}
